const initialState = {
    isLoading: true,
    Token: null,
    UsernameF: "",
    PasswordF: "",
  };
  export default initialState;
  